<template>
  <div class="prop-common fade" ref="popup">
    <slot />
  </div>
</template>

<script>
export default {
  name: "popup",

  mounted() {
    this.$nextTick(() => {
      setTimeout(this.fade, 100);
    })
    this.setBodyStyle();
  },

  beforeDestroy() {
    this.resetBodyStyle();
  },

  methods: {
    setBodyStyle() {
      this.$nextTick(() => {
        const body = document.body;
        if (body) {
          body.style.maxHeight = '100vh';
          body.style.overflowY = 'hidden';
        }
      })
    },
    resetBodyStyle() {
      this.$nextTick(() => {
        const body = document.body;
        if (body) {
          body.style.maxHeight = 'auto';
          body.style.overflowY = 'auto';
        }
      })
    },
    fade() {
      const popup = this.$refs.popup;
      if (popup) {
        popup.className += ' in';
      }
    }
  }
}
</script>

<style lang="scss">
.prop-common.fade {
  & > .wrap-common {
    transition: all 0.2s ease;
    opacity: 0.1;
    top: 60%
  }

  &.in > .wrap-common {
    opacity: 1;
    top: 50%;
  }
}
</style>